export const REACT_NATIVE_API = process.env.NODE_ENV === "development" ? "http://v1.localhost" : 'https://api.ecomseating.com'
//export const REACT_NATIVE_API = 'https://api.ecomseating.com'
export const REACT_NATIVE_APIV2 = process.env.NODE_ENV === "development" ? "http://v2.localhost" : 'https://apiv2.ecomseating.com'
//export const REACT_NATIVE_APIV2 = 'https://apiv2.ecomseating.com'
export const REACT_NATIVE_S3 = "https://d2in4d3ntxbclu.cloudfront.net"